import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalType } from 'src/types/types'

type ModalStateType = {
  type: ModalType
  text?: string
  cancelFunc?: () => void
  confirmFunc?: (text?: string) => void
  className?: string
}

export type ModalDataTypes = ModalStateType & {
  unlockDeviceInputValue: string
  deleteDataInputValue: string
  isOpen: boolean
}

const initialState: ModalDataTypes = {
  type: 'alert',
  text: '',
  cancelFunc: () => {},
  confirmFunc: (text?: string) => {},
  unlockDeviceInputValue: '',
  deleteDataInputValue: '',
  isOpen: false,
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModalItems(state, action: PayloadAction<ModalStateType>) {
      const { type, text, className, cancelFunc, confirmFunc } = action.payload
      state.type = type
      state.text = text
      state.cancelFunc = cancelFunc
      state.confirmFunc = confirmFunc
      state.className = className
      state.isOpen = true
    },
    setUnlockDeviceInputValue(state, action) {
      state.unlockDeviceInputValue = action.payload
    },
    setDeleteDataInputValue(state, action) {
      state.deleteDataInputValue = action.payload
    },
    setCloseModal(state) {
      state.isOpen = false
      state.type = 'alert'
      state.className = undefined
    },
  },
})

export const { setDeleteDataInputValue, setCloseModal, setModalItems, setUnlockDeviceInputValue } =
  modalSlice.actions

export default modalSlice.reducer
